import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import h from 'react-hyperscript';
import {Button, Dialog, InputAdornment} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Event from '@material-ui/icons/Event';
import {eyebrow} from 'Components/Typography/Typography';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import {ENDPOINTS, getAccessToken} from 'Src/utils/utils';
import content from 'Assets/data/report-card-overview.json';
import {DatePicker, MuiPickersUtilsProvider}
  from '@material-ui/pickers';
import './UpdateProductWindow.scss';

const PRODUCT_WINDOW_LENGTH = 12; // weeks
const pdwContent = content.updateProductWindow;

const formatDataWindow = (startDate) => {
  const endDate = moment(startDate).add(PRODUCT_WINDOW_LENGTH, 'weeks');
  const formattedStart = startDate.format('MM/DD/YYYY');
  const formattedEnd = endDate.format('MM/DD/YYYY');
  return (formattedStart + ' - ' + formattedEnd);
};

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '0px 16px',
    margin: 0,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    margin: '22px 16px 12px 16px',
  },
}))(MuiDialogActions);

export default function UpdateProductWindow(props) {
  const [open, setOpen] = React.useState(false);

  const [currentStartDate, updateCurrentStartDate] = React.useState(
      moment(props.userStatus.current_product_metrics_date));

  const [prevStartDate, updatePrevStartDate] = React.useState(
      moment(props.userStatus.previous_product_metrics_date));

  const [productWindowsChanged, setProductWindowsChanged] =
      React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handlePrimaryWindowDateChange = (date) => {
    updateCurrentStartDate(date);
    const primaryDate = date.format('YYYY-MM-DD');
    const data = {
      access_token: getAccessToken(props.googleUser),
      primary_date: primaryDate,
      district_id: window.localStorage.getItem('districtId'),
      primary_domain: window.localStorage.getItem('primaryDomain'),
      rcd_id: window.localStorage.getItem('rcdId'),
      survey_id: window.localStorage.getItem('surveyId'),
    };
    setProductDataWindow(data);
  };

  const handlePreviousWindowDateChange = (date) => {
    updatePrevStartDate(date);
    const secondaryDate = date.format('YYYY-MM-DD');
    const data = {
      access_token: getAccessToken(props.googleUser),
      secondary_date: secondaryDate,
      district_id: window.localStorage.getItem('districtId'),
      primary_domain: window.localStorage.getItem('primaryDomain'),
      rcd_id: window.localStorage.getItem('rcdId'),
      survey_id: window.localStorage.getItem('surveyId'),
    };
    setProductDataWindow(data);
  };

  const handleUnsavedClose = () => {
    if (productWindowsChanged) {
      const data = {
        access_token: getAccessToken(props.googleUser),
        primary_date: props.userStatus.current_product_metrics_date,
        secondary_date: props.userStatus.previous_product_metrics_date,
        district_id: window.localStorage.getItem('districtId'),
        primary_domain: window.localStorage.getItem('primaryDomain'),
        rcd_id: window.localStorage.getItem('rcdId'),
        survey_id: window.localStorage.getItem('surveyId'),
      };
      setProductDataWindow(data);
    }
    updateCurrentStartDate(
        moment(props.userStatus.current_product_metrics_date));
    updatePrevStartDate(
        moment(props.userStatus.previous_product_metrics_date));
    handleClose();
  };

  const handleSubmit = () => {
    if (productWindowsChanged) {
      props.setProductWindowsLoading(true);
      props.userStatus.current_product_metrics_date =
          currentStartDate.format('YYYY-MM-DD');
      props.userStatus.previous_product_metrics_date =
          prevStartDate.format('YYYY-MM-DD');
      // Waits 4 seconds for pdw to set
      setTimeout(() => props.setProductWindowsLoading(false), 4000);
    }
    handleClose();
  };

  function setProductDataWindow(data) {
    setProductWindowsChanged(true);
    fetch(ENDPOINTS.SET_PRODUCT_METRICS_WINDOW, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': props.googleUser.getAuthResponse().id_token,
        'X-CSRF-Token': props.csrf,
      },
      body: JSON.stringify(data),
    })
        .then((response) => response.json())
        .then(
            (result) => {
              if (result.success != true) {
                console.error('PDWs response needs attention:', result);
              }
            },
            (err) => {
              console.error('Failed to save product data window:', err);
            }
        );
  }

  return (
    h('div', {className: 'update-pdw'}, [
      h('a', {
        className: 'button button--inline',
        onClick: handleClickOpen,
      }, [
        h('span', {
          className: 'material-icons padding-right--micro',
        }, 'update'),
        'Update product data windows',
      ]),
      h(Dialog, {
        'onClose': handleUnsavedClose,
        'key': 'product-data-window-modal',
        'aria-labelledby': 'customized-dialog-title',
        'open': open,
      }, [
        h('div', {
          className: 'update-pdw-background',
          onClick: () => handleUnsavedClose(),
        }, null),

        h('div', {
          className: 'update-pdw__card',
        }, [
          h(MuiDialogTitle, {
            className: 'update-pdw__title',
          }, [
            h('span', {
              className: 'update-pdw__icon material-icons',
            }, 'update'),
            'Customize your product data reporting windows',
            h('p', {className: 'update-pdw__copy'}, pdwContent.description),
            h('p', [
              'Note:',
              h('ul', [
                pdwContent.notes.map((note) =>
                  h('l1', {style: {display: 'list-item'}}, note)
                ),
              ]),
            ]),
            h(IconButton, {
              label: 'close',
              className: 'close-button',
              id: 'product-data-modal__close',
              onClick: handleUnsavedClose,
            }, [
              h(CloseIcon, [
              ])]),
          ]),
          h(DialogContent, {
            dividers: false,
            className: 'update-pdw__content',
          }, [
            h(
                'div',
                {
                  className: 'update-pdw__container',
                },
                [
                  h(MuiPickersUtilsProvider, {utils: MomentUtils}, [
                    h(TooltipGroup, {
                      title: pdwContent.currentPeriod.tooltip,
                    }, h(eyebrow, {
                      className: 'update-pdw__eyebrow-label',
                    }, pdwContent.currentPeriod.title)),
                    h(
                        DatePicker,
                        {
                          disableToolbar: 'true',
                          className: 'update-pdw__datepicker',
                          key: 'current-period__datepicker',
                          variant: 'inline',
                          inputVariant: 'outlined',
                          autoOk: true,
                          minDate: moment.max(
                              moment(prevStartDate)
                                  .subtract(PRODUCT_WINDOW_LENGTH, 'weeks'),
                              moment(new Date()).subtract(6, 'months')
                          ),
                          minDateMessage: pdwContent.currentPeriod.message,
                          maxDate: moment(new Date())
                              .subtract(PRODUCT_WINDOW_LENGTH, 'weeks')
                              .subtract(5, 'days'),
                          maxDateMessage: pdwContent.currentPeriod.message,
                          InputProps: {
                            endAdornment: h(InputAdornment, {position: 'end'}, [
                              h(IconButton, {}, [
                                h(Event, {}),
                              ]),
                            ]),
                          },
                          label: 'Choose a start date',
                          labelFunc: formatDataWindow,
                          value: currentStartDate,
                          onChange:
                            (date) => handlePrimaryWindowDateChange(date),
                        },
                        null
                    ),

                    h(TooltipGroup, {
                      title: pdwContent.previousPeriod.tooltip,
                    }, h(eyebrow, {
                      className: 'update-pdw__eyebrow-label',
                    }, pdwContent.previousPeriod.title)),
                    h(DatePicker, {
                      disableToolbar: 'true',
                      className: 'update-pdw__datepicker',
                      key: 'previous-period__datepicker',
                      variant: 'inline',
                      width: '100%',
                      inputVariant: 'outlined',
                      autoOk: true,
                      minDate: moment().subtract(24, 'months'),
                      minDateMessage: pdwContent.previousPeriod.message,
                      maxDate: moment(currentStartDate)
                          .subtract(PRODUCT_WINDOW_LENGTH, 'weeks'),
                      maxDateMessage: pdwContent.previousPeriod.message,
                      InputProps: {
                        endAdornment: h(InputAdornment, {position: 'end'}, [
                          h(IconButton, {}, [
                            h(Event, {}),
                          ]),
                        ]),
                      },
                      label: 'Choose a start date',
                      labelFunc: formatDataWindow,
                      value: prevStartDate,
                      inputadornmentprops: {position: 'end'},
                      onChange: (date) => handlePreviousWindowDateChange(date),
                    },
                    null
                    ),
                  ]),
                ],
            ),
          ]),
          h(DialogActions, [
            h(Button, {
              className: 'update-pdw__cancel',
              onClick: handleUnsavedClose,
              color: 'primary',
            },
            ['Cancel']),
            h(Button, {
              className: 'update-pdw__save',
              color: 'primary',
              variant: 'contained',
              size: 'medium',
              onClick: () => handleSubmit(),
              color:
              'primary'},
            ['Save']),
          ]),
        ]),
      ]),
    ])
  );
}
